var map = {
	"./animations.scss": "bc44",
	"./colors.scss": "62d7",
	"./desktop.css": "ebf2",
	"./index.scss": "139c",
	"./main.css": "845f",
	"./mixins.scss": "ebdc",
	"./typography.scss": "db8c",
	"./video.svg": "8e0f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";